var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.goBackToScripts()
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "arrow-left" } }),
                      _vm._v(" Back to Scripts "),
                    ],
                    1
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: `Switch to edit mode`,
                          expression: "`Switch to edit mode`",
                        },
                      ],
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toEditPage()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "w-col",
                        [
                          _c(
                            "w-button-bar",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: `Show Properties`,
                                      expression: "`Show Properties`",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.showScriptProperties()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "list" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "", center: "" } },
        [
          _c(
            "transition",
            { staticClass: "fast-fade", attrs: { mode: "out-in" } },
            [
              !_vm.ready
                ? _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular")],
                    1
                  )
                : _c(
                    "w-col",
                    { style: { height: "100%" }, attrs: { grow: "" } },
                    [
                      _c(
                        "w-card",
                        {
                          staticClass: "grow",
                          style: { maxHeight: "100%" },
                          attrs: { tag: "w-card" },
                        },
                        [
                          _c("w-card-title", [_vm._v(_vm._s(_vm.script.Name))]),
                          _c(
                            "w-scroll-view",
                            {
                              staticClass: "grow no-margin",
                              attrs: { tag: "w-col" },
                            },
                            [
                              _c("codemirror", {
                                ref: "codeEditor",
                                staticClass: "grow",
                                attrs: { options: _vm.cmOptions },
                                model: {
                                  value: _vm.script.Content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.script, "Content", $$v)
                                  },
                                  expression: "script.Content",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.propertiesModal,
            callback: function ($$v) {
              _vm.propertiesModal = $$v
            },
            expression: "propertiesModal",
          },
        },
        [
          _c("app-dossier-script-show-properties", {
            attrs: { script: _vm.script },
            on: {
              close: function ($event) {
                _vm.propertiesModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }